import { render, staticRenderFns } from "./venueList.vue?vue&type=template&id=dc4443b2&"
import script from "./venueList.vue?vue&type=script&lang=js&"
export * from "./venueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports